import type { IconSvgObject } from './types';

const LayerMask01Icon: IconSvgObject = [
  ["path", { d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 20L19 5", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16 9L22 13.8528M12.4128 12.4059L19.3601 18.3634M8 15.6672L15 21.5", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default LayerMask01Icon;
